@if (isNew()) {
    @if (newServoOptions().length != 0) {
        <div class="row normal-row">
            <meta-select-button 
                [availableMetas]="this.newServoOptions()"
                [alreadySelected]="this.alreadySelectedFN()"
                (onSelect)="onNew($event)"
                [labelCbObs]="this.labelFn()" />
        </div>                
    }
} @else if (this.onlyContents()) {
    @let sc = this.components();
    <div class="row normal-row clickable" [class.parent-bck]="!this.showFocus" [class.key-select]="this.showFocus" (click)="onEdit()">{{sc?.index | tkdata:'servo':{'default': meta()?.omschr?.toString()} | async }}</div>
    <div class="row normal-row clickable" [class.parent-bck]="!this.showFocus" [class.key-select]="this.showFocus" (click)="onEdit()">{{sc?.soort}}</div>
    <div class="row normal-row clickable" [class.parent-bck]="!this.showFocus" [class.key-select]="this.showFocus" (click)="onEdit()">{{sc?.uitgang}}</div>
    @for (param of sc?.params; track $index) {
        <div class="row normal-row clickable" [class.parent-bck]="!this.showFocus" [class.key-select]="this.showFocus" (click)="onEdit()">{{param}}</div>
    }

} @else {
<div class="row normal-row clickable" [class.parent-bck]="!this.showFocus" [class.key-select]="this.showFocus" (click)="onEdit()">
    
        @if (!this.onlyDesc()) {
            <span [title]="meta()?.index">{{meta()?.index | tkdata:'servo':{'default': meta()?.omschr?.toString()} | async }}
            @if (this.initialValue()?.soort == 6) {
                : MB  {{this.findMBNetwork(this.initialValue()?.modbusNetworkId)}}({{this.initialValue()?.stationnr}})
            } @else {
                : {{this.initialValue()?.uitgang}}{{this.initialValue()?.inverted ? "!" : ""}} 
            }
            </span>
            @let sc = this.components();
            <div>
                @for (param of sc?.params; track $index) {
                    <span class="param">{{param}}</span>
                }
            </div>
        } @else {
            <span [title]="meta()?.index">{{meta()?.index | tkdata:'servo':{'default': meta()?.omschr?.toString()} | async }}</span>

        }
    
</div>
}
<kendo-dialog *ngIf="this.isEditing" title="Edit Servo {{meta()?.index | tkdata:'servo':{'default': meta()?.omschr?.toString()} | async }}" 
    width="700px" (close)="this.close()" autoFocusedElement="kendo-dropdownlist">
    <div>
        <fieldset :class="row split">
            <legend :class="legend">Output:</legend>

            <kendo-label text="Type">

                <kendo-dropdownlist [data]="servoTypes()" [textField]="'text'" [valueField]="'type'"
                    [valuePrimitive]="true" [(value)]="editValue.soort" (valueChange)="this.checkValid()"/>
            </kendo-label>
            @if (editValue.soort == 6) {
                <kendo-label text="Node ID">
                    <kendo-numerictextbox [(value)]="editValue.stationnr" format="n0" [min]="0" (valueChange)="this.checkValid()"
                        [style]="{ width: '70px' }"></kendo-numerictextbox>
                </kendo-label>
                <kendo-label text="ModBus Network">

                    <kendo-dropdownlist [data]="modbusNetworks()" [textField]="'label'" [valueField]="'index'" (valueChange)="this.checkValid()"
                        [valuePrimitive]="true" [(value)]="editValue.modbusNetworkId" />
                </kendo-label>
    
            } @else {
                <!-- @let outputType = (editValue.soort == 5 || editValue.soort == 4) ? "Analog Uitgang" : "Digital Uitgang"; -->
                @if (editValue.soort == 1) {
                    <kendo-label text="Tijd">
                        <kendo-maskedtextbox [(value)]="editValue.looptijd" mask="00:00"
                            [style]="{ width: '100px' }"></kendo-maskedtextbox>
                    </kendo-label>
                        
                }
                @let kType = this.kanaalService.getServoKanaalType(this.editValue);
                @if (kType != undefined) {
                    @let rType = {
                        ioType: kType.ioType,
                        range: kType.range,
                        start: kType.start,
                        inverted: this.editValue.inverted,
                        volt: this.editValue.volt
                    };
                    <kanaal-input [initialValue]="rType" [assignement]="this.assignment()" (valueChanged)="onKanaalInputChanged($event)" [showTypeLabel]="true" ></kanaal-input>                            
                }
            }
        </fieldset>
    </div>
    <div>
        @for (paramMeta of paramsMeta(); track paramMeta.pmeta.no) {
        <fieldset :class="cell" *ngIf="this.editValue.params[paramMeta.pmeta.no] != undefined">
            <legend :class="legend">{{meta()?.index+'.'+(paramMeta.pmeta.no+1) | tkdata:'servoparam':{'default': paramMeta.pmeta.omschr.toString()} | async }} - {{servoParamTypeLabel(editValue.params[paramMeta.pmeta.no]) }}</legend>
            @let type = this.kanaalService.getKCParamType(editValue.params[paramMeta.pmeta.no]);
            @if (type != undefined) {
                @let rType = {ioType: type.ioType, range: type.range, start: type.start, inverted: editValue.params[paramMeta.pmeta.no].inverted};
                <kanaal-input [assignement]="paramMeta.assign" [initialValue]="rType" 
                    (valueChanged)="this.onParamKanaalChange($event, paramMeta.pmeta.no)" [autofilKanaal]="false"></kanaal-input>    
            } @else {
                <kendo-numerictextbox [(value)]="editValue.params[paramMeta.pmeta.no].waarde" format="n0"
                [style]="{ width: '100px' }"></kendo-numerictextbox>
            }

        </fieldset>
        }
    </div>
    <kendo-dialog-actions>
        <button kendoButton (click)="this.close()">Cancel</button>
        <button kendoButton (click)="onDelete()" themeColor="primary" *ngIf="!isNew()">
            Delete
        </button>
        <button kendoButton (click)="onSave()" themeColor="primary" [disabled]="!isValid">
            Save
        </button>
    </kendo-dialog-actions>
</kendo-dialog>
